import DealServiceNest from '@/bundles/Deals/services/DealServiceNest';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { httpV2 } from '@/bundles/Http/factory/httpFactory';

function dealServiceNestFactory () {
  return new DealServiceNest(
    httpV2,
    new ErrorMapper(),
  );
}

export const dealServiceNest = dealServiceNestFactory();
